import { Box, Stack, ThemeProvider, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Add, Remove } from '@mui/icons-material';
import './NumberSelector.scss';
import { CacheProvider } from '@emotion/react';
import { cacheLtr } from '../../utils/GeneralUtils';
import { OrderPageButton } from '../themedComponents/OrderPageButton';
import { OrderPageTypography } from '../themedComponents/OrderPageTypography';

type NumberSelectorProps = {
  value: number;
  setValue: (value: number) => void;
  min: number;
  max?: number;
  disabled?: boolean;
  isAddButtonDisabled?: boolean;
  isRemoveDisabled?: boolean;
};
const NumberSelector = ({
  value,
  setValue,
  min,
  max,
  disabled,
  isAddButtonDisabled,
  isRemoveDisabled,
}: NumberSelectorProps) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const changeVal = (val: number) => {
    if (!!max && val > max) {
      val = max;
    }
    if (val < min) {
      val = min;
    }
    setValue(val);
  };

  return (
    <CacheProvider value={cacheLtr}>
      <ThemeProvider theme={{ ...theme, direction: 'ltr' }}>
        <Stack spacing={1} direction="row" className="number-selector">
          <OrderPageButton
            className="number-button"
            aria-label={t('order_page.decreaseParticipants')}
            onClick={() => changeVal(value - 1)}
            variant="contained"
            disabled={disabled || isRemoveDisabled}
            $disabled={disabled || isRemoveDisabled}>
            <Remove style={{ color: theme.customTheme.palette.text.button.numberSelector }} />
          </OrderPageButton>

          <Box className="value-box">
            <OrderPageTypography variant="h3">{value}</OrderPageTypography>
          </Box>

          <OrderPageButton
            className="number-button"
            aria-label={t('order_page.increaseParticipants')}
            onClick={() => changeVal(value + 1)}
            variant="contained"
            disabled={disabled || isAddButtonDisabled}>
            <Add style={{ color: theme.customTheme.palette.text.button.numberSelector }} />
          </OrderPageButton>
        </Stack>
      </ThemeProvider>
    </CacheProvider>
  );
};

export default NumberSelector;
